import { RouteRecordRaw } from 'vue-router'

import dashboardRoutes from './dashboard'
import adminRoutes from './admin'

// 异步路由集合
export const asyncRoutes: RouteRecordRaw[] = [...dashboardRoutes, ...adminRoutes]

export default asyncRoutes
